export type ScoreTone = "success" | "warning" | "error";

export const getScoreTone = (earned: number, max: number): ScoreTone => {
	const ratio = max > 0 ? earned / max : 0;
	if (ratio >= 1) {
		return "success";
	}
	return ratio > 0.5 ? "warning" : "error";
};

export const formatPoints = (value: number) =>
	Number.isInteger(value) ? String(value) : value.toFixed(1);
